import React, { useEffect, useState } from 'react'

import './layout.css'

import Sidebar from '../sidebar/Sidebar'
import TopNav from '../topnav/TopNav'
import Routes from '../Routes'
import CrmAuthGate from '../auth/CrmAuthGate'

import { BrowserRouter, Route } from 'react-router-dom'

import { useSelector, useDispatch } from 'react-redux'

import ThemeAction from '../../redux/actions/ThemeAction'
import { fetchCurrentUserAccess } from '../../lib/crmClient'

const AccessLoader = ({ email, onAccessChange }) => {
    useEffect(() => {
        let cancelled = false
        const controller = new AbortController()

        onAccessChange({ canViewAllJobs: false, loadedFor: '' })

        const run = async () => {
            try {
                const result = await fetchCurrentUserAccess({ email, signal: controller.signal })
                if (!cancelled) {
                    onAccessChange({ canViewAllJobs: Boolean(result.canViewAllJobs), loadedFor: email || '' })
                }
            } catch {
                if (!cancelled) {
                    onAccessChange({ canViewAllJobs: false, loadedFor: email || '' })
                }
            }
        }

        run()

        return () => {
            cancelled = true
            controller.abort()
        }
    }, [email, onAccessChange])

    return null
}

const Layout = () => {

    const themeReducer = useSelector(state => state.ThemeReducer)
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 900)
    const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false)
    const [access, setAccess] = useState({ canViewAllJobs: false, loadedFor: '' })

    const dispatch = useDispatch()

    useEffect(() => {
        const persistedTheme = localStorage.getItem('themeMode')
        const themeClass = persistedTheme || 'theme-mode-dark'
        const colorClass = 'theme-color-orange'

        if (!persistedTheme) {
            localStorage.setItem('themeMode', themeClass)
        }
        localStorage.setItem('colorMode', colorClass)

        dispatch(ThemeAction.setMode(themeClass))

        dispatch(ThemeAction.setColor(colorClass))
    }, [dispatch])

    useEffect(() => {
        const onResize = () => {
            const nextIsMobile = window.innerWidth <= 900
            setIsMobile(nextIsMobile)
            if (!nextIsMobile) {
                setMobileSidebarOpen(false)
            }
        }

        window.addEventListener('resize', onResize)
        return () => window.removeEventListener('resize', onResize)
    }, [])

    return (
        <CrmAuthGate>
            {({ email, signOut }) => (
                <BrowserRouter>
                    <AccessLoader email={email} onAccessChange={setAccess} />
                    <Route render={(props) => (
                        <div className={`layout ${themeReducer.mode} ${themeReducer.color} ${sidebarCollapsed ? 'sidebar-collapsed' : ''} ${isMobile ? 'layout--mobile' : ''}`}>
                            <Sidebar
                                {...props}
                                collapsed={sidebarCollapsed}
                                isMobile={isMobile}
                                mobileOpen={mobileSidebarOpen}
                                onCloseMobile={() => setMobileSidebarOpen(false)}
                                onToggleCollapse={() => setSidebarCollapsed((prev) => !prev)}
                                canViewAllJobs={access.loadedFor === email && access.canViewAllJobs}
                            />
                            {isMobile && mobileSidebarOpen ? (
                                <button
                                    type="button"
                                    className="layout__mobile-overlay"
                                    onClick={() => setMobileSidebarOpen(false)}
                                    aria-label="Zavřít menu"
                                />
                            ) : null}
                            <div className="layout__content">
                                <TopNav
                                    email={email}
                                    onSignOut={signOut}
                                    showMobileMenuButton={isMobile}
                                    onToggleMobileMenu={() => setMobileSidebarOpen((prev) => !prev)}
                                />
                                <div className="layout__content-main">
                                    <Routes
                                        email={email}
                                        canViewAllJobs={access.loadedFor === email && access.canViewAllJobs}
                                        accessLoaded={access.loadedFor === email}
                                    />
                                </div>
                            </div>
                        </div>
                    )}/>
                </BrowserRouter>
            )}
        </CrmAuthGate>
    )
}

export default Layout
